<template>
    <ModalSendMail
        v-bind:TitleWindow="'Send by E-Mail'"
        @ModalClickOk="sendEmailClick"  
        v-bind:ModalId="modalSendMail"
        v-bind:Subject="conformSubject"
        v-bind:Cc="cc"
        v-bind:To="to"
        v-bind:Body="body">
    </ModalSendMail>
</template>

<script>
import GlobalService from '@/services/global.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import { EventBus } from '@/event-bus.js';

export default {
    name: 'CSVExportHelper',
    mixins: [ShowMessage],

    props: { 
        conformSubject: String,
        sendEmailAPI: String,
        exportCsvAPI: String
    },

    data() {
        return {
            modalSendMail: "SendMailId",
            parameters: {},
            sendPdfEmail: false,
            pdfParameters: {},
            cc:'',
            body:'',
            to:''
        }
    },

    methods: {
        exportCSV(parameters) {
            return new Promise((resolve, reject) => {
                EventBus.$emit('ShowWeel', true); 
                this.parameters = {...parameters};
                this.parameters.PageNumber = null;
                this.parameters.PageSize = null;

                GlobalService
                    .exportCSV(this.exportCsvAPI, this.parameters)
                    .then((response) => {      
                        if (response.data) {
                            var baseurl = this.$store.state.apiurl.replace('/api/', '');
                            this.exportFromUrl(baseurl + response.data.url, response.data.fileName);
                        }  
                        EventBus.$emit('ShowWeel', false);
                        resolve(response);      
                    })
                    .catch(error => {           
                        EventBus.$emit('ShowWeel', false);
                        reject(error); 
                        this.showResponseErrorMessage(error);
                    });
                });
            
        },

        async exportFromUrl(url, filename) {          
            const data = await fetch(url)
            const blob = await data.blob()
            const objectUrl = URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.setAttribute('href', objectUrl)
            link.setAttribute('download', filename)
            link.style.display = 'none'
            document.body.appendChild(link)                          
            link.click()                          
            document.body.removeChild(link)
        },

        emailCSV(parameters) {
            this.sendPdfEmail = false;
            this.parameters = {...parameters};
            this.parameters.PageNumber = null;
            this.parameters.PageSize = null;
            this.to = '';
            this.cc = '';
            this.body = '';
            this.$bvModal.show(this.modalSendMail);
        },

        async sendEmailClick(To, Cc, Subject, Body) {
            if (this.sendPdfEmail) {
                return this.sendPdfEmailClick(To, Cc, Subject, Body);
            }

            let params = {
                ...this.parameters,
                to: To,
                cc: Cc ? Cc : null,
                subject: Subject,
                body: Body ? Body : null
            };

            this.to = To;
            this.cc = Cc;
            this.body = Body;

            EventBus.$emit('ShowWeel', true); 
            await GlobalService
                .sendEmail(this.sendEmailAPI, params)
                .then(response => {
                    let resp = response
                    if (resp.data.success == true)
                        this.showMessage(this.$t('Shared.SharedEmailCSV'), this.$t('CustomExports.EmailWasSent'));
                    else 
                        this.showMessage(this.$t('Shared.SharedEmailCSV'), resp.data.errorMessage, "error");

                    EventBus.$emit('ShowWeel', false); 
                })
                .catch(error => {
                    EventBus.$emit('ShowWeel', false); 
                    this.showResponseErrorMessage(error);
                });
        },

        exportToPdf(reportName, isAnAPIReport, isANotesReport, params) {
            return new Promise((resolve, reject) => {
                EventBus.$emit('ShowWeel', true); 
                GlobalService
                    .exportToPdf({reportName: reportName, isAnAPIReport: isAnAPIReport, isANotesReport: isANotesReport}, params)
                    .then((response) => {      
                        if (response.data) {
                            var baseurl = this.$store.state.apiurl.replace('/api/', '');
                            this.exportFromUrl(baseurl + response.data.url, response.data.fileName);
                        }  
                        EventBus.$emit('ShowWeel', false);
                        resolve(response);     
                    })
                    .catch(error => {           
                        EventBus.$emit('ShowWeel', false); 
                        reject(error);
                        this.showResponseErrorMessage(error);
                    });
                });
        },

        emailPdf(reportName, isAnAPIReport, isANotesReport, parameters) {
            this.pdfParameters = {
                reportName: reportName, 
                isAnAPIReport: isAnAPIReport, 
                isANotesReport: isANotesReport
            };
            
            this.sendPdfEmail = true;
            this.parameters = [...parameters];
            this.to = '';
            this.cc = '';
            this.body = '';
            this.$bvModal.show(this.modalSendMail);
        },

        async sendPdfEmailClick(To, Cc, Subject, Body) {
            let params = {
                ...this.pdfParameters,
                to: To,
                cc: Cc ? Cc : null,
                subject: Subject,
                body: Body ? Body : null
            };

            this.to = To;
            this.cc = Cc;
            this.body = Body;

            EventBus.$emit('ShowWeel', true); 
            await GlobalService
                .sendPdfEmail(params, this.parameters)
                .then(response => {
                    let resp = response
                    if (resp.data.success == true)
                        this.showMessage(this.$t('Shared.SharedEmailPDF'), this.$t('CustomExports.EmailWasSent'));
                    else 
                        this.showMessage(this.$t('Shared.SharedEmailPDF'), resp.data.errorMessage, "error");

                    EventBus.$emit('ShowWeel', false); 
                })
                .catch(error => {
                    EventBus.$emit('ShowWeel', false); 
                    this.showResponseErrorMessage(error);
                });
        }
    }
}
</script>
